import { Injectable } from '@angular/core';
import { EventHoveringArg } from '@fullcalendar/core';
import { ConfigurationService } from '@sc/data-access-configuration';
import { TranslatorService } from '@sc/data-access-translation';
import { DossierEventExtendedProps } from '@sc/feature-fitter-shared-libs';
import { PlanningCalendarService } from '../../planning-calendar.service';
import { AbstractTooltipService } from './abstract-tooltip.service';
import { PhoneNumberDisplayService } from '@sc/feature-contextual-display';

@Injectable({ providedIn: 'root' })
export class TooltipReplacementVehicleService extends AbstractTooltipService {
  constructor(
    protected planningCalendarService: PlanningCalendarService,
    protected configurationService: ConfigurationService,
    private readonly translator: TranslatorService,
    private readonly phoneNumberDisplayService: PhoneNumberDisplayService
  ) {
    super(planningCalendarService, configurationService);
  }

  generateToolTip(info: EventHoveringArg, simplified = false) {
    const extendedProps = info.event.extendedProps as DossierEventExtendedProps;

    const dossier = extendedProps.dossier;
    const fitter = extendedProps.fitter;

    return `
      <div class="tooltip-agenda dossier-event" id = "${
        dossier.id
      }" style="border-color: ${this.planningCalendarService.getDossierEventColor(
      dossier,
      fitter
    )}; background: ${this.planningCalendarService.getDossierEventBackground(
      dossier,
      fitter
    )};">

        <div>
          <p class="font-family-bold font-s">
            ${
              dossier?.claim?.car?.manufacturer && dossier?.claim?.car?.model
                ? `${
                    dossier?.claim?.car?.manufacturer +
                    ' ' +
                    dossier?.claim?.car?.model
                  }`
                : this.translator.getInstantTranslation(
                    'PlanningEventTooltip.vehicleNotFound'
                  )
            }
          </p>
        </div>

        ${
          dossier?.claim?.car?.licensePlateNumber && !simplified
            ? `<p class="font-family-main font-xs">
                ${dossier?.claim?.car?.licensePlateNumber}
              </p>`
            : ''
        }
        ${
          dossier?.claim?.car?.vehicleType && !simplified
            ? `<p class="font-family-bold font-s">${this.translator.getInstantTranslation(
                'PlanningFormAppointmentIntervention.vehicleTypeNames.' +
                  dossier?.claim?.car?.vehicleType
              )}</p>`
            : ''
        }
        <p class="font-family-main font-xs uppercase">
            ${
              (dossier?.customer?.lastname ?? '') +
              ' ' +
              (dossier?.customer?.firstname ?? '')
            }
        </p>

        ${
          dossier?.customer?.phoneNumber?.number
            ? `<p class="font-family-main font-xs">
              ${this.phoneNumberDisplayService.getInstantPhoneNumberTranslation(
                dossier?.customer?.phoneNumber?.number
              )}
            </p>`
            : ''
        }

        ${
          dossier?.appointment?.assignedReplacementVehicle
            ? `<p class="font-family-main font-xs">
               ${
                 !!dossier?.appointment?.assignedReplacementVehicle
                   ?.manufacturer ||
                 !!dossier?.appointment?.assignedReplacementVehicle?.model
                   ? (dossier?.appointment?.assignedReplacementVehicle
                       ?.manufacturer
                       ? dossier?.appointment?.assignedReplacementVehicle
                           ?.manufacturer + ' '
                       : '') +
                     (dossier?.appointment?.assignedReplacementVehicle?.model ??
                       '')
                   : dossier?.appointment?.assignedReplacementVehicle?.name
               }
             </p>
             <p class="font-family-main font-xs">
               ${
                 dossier?.appointment?.assignedReplacementVehicle
                   ?.licensePlateNumber ?? ''
               }
             </p>`
            : ''
        }

      </div>
    `;
  }
}
